import { Modal } from "react-bootstrap";
import { Contest } from "interfaces/leaderboard/contest";
import styles from "./styles.module.css";
import { sparketBlack } from "utils/constants.ts";
import BlockyBoldText from "components/custom-texts/blocky-bold-text.tsx";
import { useAppSelector } from "state/hooks.ts";
import BalanceDisplay from "components/common/real-money-wallet/balance-display.tsx";
import { ContestItem } from "components/contests/contest-display-items";
import ContestModalEnterContestButton from "components/contests/contest-modal/contest-modal-enter-contest-button.tsx";
import { getEntriesByContestId } from "state/slices/contests-slice.ts";
import { checkIfUserCanEnterContest } from "utils/contestEntryUtils";
import { getIntegratedAppState, IntegratedAppState } from "state/slices/integrated-app-slice.ts";
import { getGroupState } from "state/slices/group-slice.ts";
import { getContestEntryFee } from "utils/contest-group-utils.ts";
import { isIntegrationOnlyGroup } from "utils/integration-only-groups.ts";
import BlockyMediumText from "components/custom-texts/blocky-medium-text.tsx";

interface Props {
  contest: Contest;
  show: boolean;
  setShow: (show: boolean) => void;
}

const ContestModal = ({ contest, show, setShow }: Props) => {

  const userContestEntries = useAppSelector((state) => getEntriesByContestId(state, contest.id)) || [];
  const group = useAppSelector(getGroupState);
  const groupId = group.id;

  const integratedAppSlice = useAppSelector(getIntegratedAppState);

  const isRestricted =
    isIntegrationOnlyGroup(group.uri) && !integratedAppSlice.isIntegratedApp;

  const canEnterContest =
    !isRestricted && checkIfUserCanEnterContest(contest, userContestEntries);

  return (
    <Modal show={show} onHide={() => setShow(false)}>

      <Modal.Header style={{ backgroundColor: sparketBlack }} closeVariant={"white"} closeButton>
        <BlockyBoldText
          style={{ color: "white", marginLeft: 10 }}
        >
          Contest Details
        </BlockyBoldText>
      </Modal.Header>
      <div className={styles.modal}>
        <div className={styles.body}>

          {integratedAppSlice.state === IntegratedAppState.NOT_INTEGRATED && <BalanceDisplay />}


          <ContestItem
            contest={contest}
            showStatus
            userContestEntries={userContestEntries}
            entryFeeOverride={getContestEntryFee(contest, groupId)}
          />

          {canEnterContest && <ContestModalEnterContestButton contest={contest} setShowModal={setShow} />}

          {isRestricted && (
            <div className={"m-3 text-center text-white"}>
              <BlockyMediumText>
                This contest is only available inside the {group.name} app. Please re-open Sparket from there.
              </BlockyMediumText>
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default ContestModal;